import moment from 'moment';
import { ConsoleLog } from './consoleLog';
const logger = new ConsoleLog();

const timeRangeValid = (range) => {
  if (range == null || range.startTime == null || range.endTime == null ) {
    logger.error('invalid range', { fn: timeRangeValid.name });
    return false;
  }
  return true;
}

const isTimeInRange = (time, range) => {
  let timeInRange = false;
  if (timeRangeValid) {
    timeInRange = time.isBetween(range.startTime, range.endTime, null,'[)')
  }
  logger.debug('checked time in range', { fn: isTimeInRange.name, timeInRange, time: time.format(), startTime: range.startTime.format(), endTime: range.endTime.format() } );
  return timeInRange;
}

export const isTimeInRanges = (time, ranges) => {
  let timeInRanges = false;
  if (ranges == null) {
    logger.error('invalid ranges', { fn: isTimeInRanges.name });
    return timeInRanges;
  }
  timeInRanges = ranges.some( range => isTimeInRange(time, range));
  return timeInRanges;
}


